import { RotateCw } from "lucide-react";
import { useRouteError } from "react-router";

import { Button } from "@/components/ui";
import { useT } from "@/i18n/provider";

/**
 * When a page cannot open, instead of the router's technical message.
 *
 * The usual cause is a new version published while the app was open: each
 * page's file has a new name, the old one is gone, and the next page opened
 * fails to load. A reload gets the new version. So it says that, plainly,
 * with a Reload button; anything else gets the plain "could not open".
 */
export function RouteError() {
  const t = useT();
  const error = useRouteError();
  const message = error instanceof Error ? error.message : "";
  const updated = /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(message);

  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center gap-5 p-6 text-center">
      <img src="/icon-192.png" alt="" width={72} height={72} className="rounded-card" />
      <p role="alert" className="max-w-md text-heading font-bold text-text">
        {updated ? t.appUpdated : t.pageFailed}
      </p>
      <Button icon={RotateCw} label={t.reload} onClick={() => window.location.reload()} />
    </main>
  );
}
